// @atlas/contracts — a `support-teams` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
import { nullableStr } from '../_shared/schemas.js';
// walking skeleton tracer-contract — a valódi modul-contractok inkrementálisan kerülnek bele
/** Egy support-csapat tagja (belső munkatárs) — a név-részek a locale-tudatos megjelenítéshez (mint az employees). */
export const SupportTeamMemberSchema = z.object({
    id: z.string(),
    displayName: z.string().nullable(),
    givenName: z.string().nullable(),
    familyName: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    teamColor: z.string().nullable(),
});
/** Egy support-csapathoz tartozó szolgáltatás (billing/services, `support_team_id` kereszt-namespace FK) —
 *  id + a `lang` szerint feloldott név (a ticket-leadásnál releváns: mely szolgáltatások tartoznak a csapathoz). */
export const SupportTeamServiceSchema = z.object({
    id: z.string(),
    name: z.string(),
});
/** Egy support-csapat lista-sora — a név a `lang` szerint feloldva; a listaoldal a leírás helyett az `email`-t
 *  mutatja (a `description` továbbra is elérhető). A tagok belső munkatársak; a szolgáltatások a hozzá kötött
 *  billing-szolgáltatások (ticket-leadás). */
export const SupportTeamRowSchema = z.object({
    id: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    email: z.string().nullable(),
    members: z.array(SupportTeamMemberSchema),
    memberCount: z.number(),
    services: z.array(SupportTeamServiceSchema),
    // Nyers i18n a szerkesztő-előtöltéshez (a `name`/`description` a lista LOKALIZÁLT sztringje) + OCC-verzió.
    nameHu: z.string(),
    nameEn: z.string(),
    descriptionHu: z.string().nullable(),
    descriptionEn: z.string().nullable(),
    version: z.number(),
});
/**
 * A „Support-csapat" write-body (create + update): kétnyelvű név (kötelező) + kétnyelvű leírás + kapcsolattartó
 * e-mail + a tagok (belső identityk) cél-halmaza (a szerver diffeli a meglévő members-sorokkal). A `name`/
 * `description` az Odinban i18n-JSON (`{hu,en}`); a BFF a mezőkből építi.
 */
export const SupportTeamWriteBodySchema = z.object({
    nameHu: z.string().trim().min(1).max(255),
    nameEn: z.string().trim().min(1).max(255),
    descriptionHu: nullableStr(4000),
    descriptionEn: nullableStr(4000),
    /**
     * A csapat kapcsolattartó e-mail-címe — a legacy `required|email` 1:1 (mind a 10 migrált csapatnak van). Nem
     * küldés-cím: a legacy sem küldött rá (a jegy-levelek a kapcsolattartókhoz és a felelőshöz mennek), de a
     * csapat elérhetősége nélkül a sor félkész — ezért KÖTELEZŐ.
     */
    email: z.string().trim().email().max(320),
    /** A KÍVÁNT tag-halmaz (belső identity-id-k); a szerver diffeli a meglévő members-sorokkal (add/remove). */
    memberIds: z.array(z.string().uuid()),
    /** A KÍVÁNT szolgáltatás-halmaz (billing/services id-k) — a csapathoz kötött szolgáltatások (legacy client_support
     *  1:1, csak SERVICE-szint, plan NEM). A szerver diffeli: a hozzáadott szolgáltatások `supportTeamId`-ját e csapatra
     *  állítja, a levettekét null-ra. Billing-írást igényel (`write:all:billing`). */
    serviceIds: z.array(z.string().uuid()),
});
//# sourceMappingURL=schemas.js.map